import { Link } from 'react-router-dom';
import { comics, categoryLabels } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-fire-line text-primary-500 text-lg"></i>
              <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full whitespace-nowrap">热门推荐</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              大家都在看的热门漫画
            </h2>
          </div>
          <Link to="/category/korean" className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 99漫画免费${categoryLabels[comic.category]}推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                    comic.status === 'ongoing' ? 'bg-primary-500 text-background-50' : 'bg-foreground-600 text-background-50'
                  }`}>
                    {comic.status === 'ongoing' ? '连载中' : '已完结'}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded px-1.5 py-0.5">
                  <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                  <span className="text-background-50 text-[10px] font-medium">{comic.rating}</span>
                </div>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                {categoryLabels[comic.category]} · {comic.chapters}话
              </p>
            </Link>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <Link to="/category/korean" className="flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer">
            查看全部热门漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}